import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';

const TimerDisplay = ({ period, timer, competition, accentColor="rgb(0, 0, 0)", onClick }) => {
  // Split competition into lines - for "Championship League Finals" -> ["Championship", "League Finals"]
  const competitionLines = competition ? (() => {
    const words = competition.split(' ');
    if (words.length <= 1) return [competition];
    // First word on first line, rest on second line
    return [words[0], words.slice(1).join(' ')];
  })() : [];

  return (
    <Stack
      onClick={onClick}
      alignItems="center"
      justifyContent="center"
      spacing={0.5}
      sx={{
        position: 'relative',
        zIndex: 1,
        px: 2.5,
        py: 1.75,
        minWidth: 150,
        textAlign: 'center',
        borderRadius: 2,
        color: '#0E1014',
        background: 'linear-gradient(180deg, #F4F4F4 0%, #E1E1E1 100%)',
        border: '1px solid rgba(14,16,20,0.08)',
        boxShadow: '0 16px 32px rgba(0,0,0,0.22)',
        overflow: 'hidden',
        cursor: 'pointer',
        transition: 'transform 0.2s ease, boxShadow 0.2s ease',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 20px 40px rgba(0,0,0,0.28)',
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: `radial-gradient(circle at 50% 0%, ${alpha(accentColor, 0.18)} 0%, rgba(0,0,0,0) 70%)`,
          pointerEvents: 'none',
        },
        '& > *': {
          position: 'relative',
          zIndex: 1,
        },
      }}
    >
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 500,
          color: '#0E1014',
          fontFamily: '"Barlow", "Roboto", "Helvetica", Arial, sans-serif',
        }}
      >
        {period}
      </Typography>
      <Typography 
        sx={{ 
          color: '#0E1014', 
          fontSize: 36, 
          fontWeight: 700,
          fontFamily: '"Barlow", "Roboto", "Helvetica", Arial, sans-serif',
          lineHeight: 1,
        }}
      >
        {timer}
      </Typography>
      {competitionLines.length > 0 && (
        <Stack spacing={0} alignItems="center">
          {competitionLines.map((line, index) => (
            <Typography
              key={index}
              sx={{
                fontSize: 12,
                fontWeight: 500,
                color: '#0E1014',
                fontFamily: '"Barlow", "Roboto", "Helvetica", Arial, sans-serif',
                lineHeight: 1.3,
              }}
            >
              {line}
            </Typography>
          ))}
        </Stack>
      )}
    </Stack>
  );
};

TimerDisplay.propTypes = {
  period: PropTypes.string.isRequired,
  timer: PropTypes.string.isRequired,
  competition: PropTypes.string,
  accentColor: PropTypes.string,
  onClick: PropTypes.func,
};

export default TimerDisplay;

